<template>
  <div class="k-progress">
    <div class="progress-wc" :style="{width:wcWidth}">
    </div>
    <div class="progress-hg" :style="{width:hgWidth}"></div>
  </div>
</template>

<script>

export default {
  name: 'k-progress',
  props: {
    data: {
      type: Object,
      default: function () {
        return {
          hg: 0,
          wc: 0,
          zs: 0
        }
      }
    },
    maxheight: Number,
    height: Number,
    width: Number
  },
  data: function () {
    return {
      zsWidth: '100%'
    }
  },
  computed: {
    wcWidth: function () {
      return this.data.wc / this.data.zs * 100 + '%'
    },
    hgWidth: function () {
      return this.data.hg / this.data.zs * 100 + '%'
    }
  },

  mounted() {
  },

  methods: {

  }
}

</script>

<style lang="scss" scoped>
.k-progress {
  background-color: #eaeaea;
  border-radius: 4px;
  height: 6px;
  width: 98%;
  .progress-wc {
    background: linear-gradient(to right, #ffe420, #ffc60f);
    border-radius: 4px;
    height: 6px;
  }
  .progress-hg {
    background: linear-gradient(to right, #16cdd2, #06acf7);
    border-radius: 4px;
    height: 6px;
    margin-top: -6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/progress/src/progress.vue